import Component from '@glimmer/component';

export default class MwPostPlaceholder extends Component {
  constructor() {
    super(...arguments);
    this.dummyPosts = new Array(this.args.count || 3);
  }
}
